<template>
  <div>
    <el-dialog
      :visible.sync="dialogFormVisible"
      :append-to-body="true"
      customClass="way treeform"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-input placeholder="输入关键字进行过滤" v-model="filterText">
          </el-input>
          <el-tree
            class="filter-tree"
            :data="treedata"
            :props="defaultProps"
            :filter-node-method="filterNode"
            @node-click="handleNodeClick"
            ref="tree"
          >
          </el-tree>
        </el-col>
        <el-col :span="12">
          <el-checkbox-group v-model="checkList" @change="selectBox">
            <el-checkbox
              v-for="alllist in checkall"
              :label="alllist.cclassname + ':' + alllist.cclasscode"
              :key="alllist.cclasscode"
              >{{ alllist.cclassname }}</el-checkbox
            >
          </el-checkbox-group>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel()">取 消</el-button>
        <el-button type="primary" @click="handleClickTrue()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>


<script>
export default {
  props: {
    suppliestable: { Type: Object },
    treeif: { Type: Boolean },
  },
  data () {
    return {
      filterText: "",
      dialogFormVisible: this.treeif,
      treedata: [],
      checkList: [],
      suppliesData: this.suppliestable,
      defaultProps: {
        children: "children",
        label: "title",
      },
      checkall: [],
    };
  },
  watch: {
    filterText (val) {
      this.$refs.tree.filter(val);
    },
  },
  created () {
    this.BindFirst();
    for (var a = 0; a < this.suppliestable.length; a++) {
      this.checkList.push(
        this.suppliestable[a].cclassname +
        ":" +
        this.suppliestable[a].cclasscode
      );
    }
  },
  methods: {
    // checkbox点击
    selectBox (val) {
      this.suppliesData = [];
      // console.log("val", val);
      // 首先要初始化这两个数组，因为当取消checkbox的时候，数组中就不能有当前取消的值。

      val.forEach((item) => {
        const value = item.split(":")[0];
        const label = item.split(":")[1];
        var list = { cclassname: value, cclasscode: label };
        this.suppliesData.push(list);
        this.suppliesData = this.unique(this.suppliesData);
      });
    },
    // 确定
    handleClickTrue () {
      this.dialogFormVisible = false;
      this.$emit("supplie", this.suppliesData, this.dialogFormVisible);
    },
    // 取消
    cancel () {
      this.suppliesData = [];
      this.dialogFormVisible = false;
      this.$emit("supplie", 1, this.dialogFormVisible);
    },
    // 树状图查询
    filterNode (value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 获取所有的物料信息
    BindFirst () {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetClassTree",
      }).then((res) => {
        console.log(res);

        if (res.data.Success) {
          var jsondata = eval(res.data.Data);
          var jsondata = JSON.parse(
            JSON.stringify(jsondata).replace(/"field"/g, '"id"')
          );
          console.log(jsondata, 111);
          this.treedata = jsondata;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 点击树状图
    handleNodeClick (data) {
      console.log(data);
      this.BindSecond(data.id);
    },
    // 获取所有子元素
    BindSecond (code) {
      console.log(code);
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetInvClassDetail",
        data: { cclasscode: code },
      }).then((res) => {
        console.log(res);

        if (res.data.Success) {
          this.checkall = res.data.Data;
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 去重
    unique (arr) {
      const res = new Map();
      return arr.filter(
        (arr) => !res.has(arr.cclasscode) && res.set(arr.cclasscode, 1)
      );
    },
  },
};
</script>